import {
  Box,
  Card,
  Title,
  Radio,
  Link,
  Icon,
  Text,
} from '@nimbus-ds/components';
import { PlusCircleIcon } from '@nimbus-ds/icons';
import { FormField } from '@nimbus-ds/patterns';
import ModalAside from 'App/components/lab/ModalAside';
import { HeaderTop, CancelAndSaveButtons } from 'commons/components';
import { useTranslationAccount } from 'domains/Account/hooks';
import TaxRateInput from '../TaxRateInput';

interface TaxExceptionsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function TaxExceptionsModal({ isOpen, onClose }: TaxExceptionsModalProps) {
  const t = useTranslationAccount('businessDataPage.taxesWithExceptions.modal');
  const headerNavigation = { onClick: onClose };

  return (
    <ModalAside
      isOpen={isOpen}
      onDidDismiss={onClose}
      headerTop={<HeaderTop navigation={headerNavigation} />}
      headerContent={<Title fontSize="h2">{t('title')} </Title>}
    >
      <Box display="flex" flexDirection="column" gap="4">
        <Card>
          <Card.Header>
            <Title as="h4">{t('name')}</Title>
          </Card.Header>
          <Card.Body>
            <Box display="flex" flexDirection="column" gap="2">
              <FormField.Input
                name="name"
                onChange={(e) => console.log(e.target.value)}
              />
              <Text>{t('helpTextName')}</Text>
            </Box>
          </Card.Body>
        </Card>
        <Card>
          <Card.Header>
            <Title as="h4">{t('alicuotaTitle')}</Title>
          </Card.Header>
          <Card.Body>
            <TaxRateInput value={10} />
          </Card.Body>
        </Card>
        <Card>
          <Card.Header>
            <Title as="h4">{t('applyTo')}</Title>
          </Card.Header>
          <Card.Body>
            <Box display="flex" flexDirection="column" gap="2">
              <Radio
                as="button"
                name="my-radio"
                label={t('buttonProducts')}
                checked
              />
              <Link
                appearance="primary"
                as="button"
                textDecoration="none"
                onClick={() => console.log('open modal')}
              >
                <Icon color="currentColor" source={<PlusCircleIcon />} />
                {t('selectProducts')}
              </Link>
            </Box>
          </Card.Body>
        </Card>
      </Box>
      <CancelAndSaveButtons
        isLoading={false}
        onCancel={onClose}
        onSave={() => console.log('save')}
        isDisabled={false}
      />
    </ModalAside>
  );
}

export default TaxExceptionsModal;
